module.exports = __webpack_public_path__ + "media/images/ic_segments-f1d6564cf6146c77b97a9b7f29e19260.svg";